module.exports = __webpack_public_path__ + "static/MiguelJimenez-e049ad20aa48252766d8e193191a09fa.jpg";